import React from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  styled,
  StepConnector,
  Box,
  Typography,
} from '@mui/material';
import { stepConnectorClasses } from '@mui/material/StepConnector';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const statuses = ['Order Placed', 'Order Confirmed', 'Ready', 'Picked up', 'Completed'];

const ModernConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },

  [`& .${stepConnectorClasses.lineVertical}`]: {
    borderLeftWidth: '3px',
    borderLeftStyle: 'solid',
    borderLeftColor: theme.palette.grey[300],
    marginLeft: '12px',
    minHeight: '24px',
  },

  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.lineVertical}`]: {
      borderLeftColor: theme.palette.warning.main,
    },
  },

  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.lineVertical}`]: {
      borderLeftColor: theme.palette.success.main,
    },
  },
}));

const ModernStepLabel = styled(StepLabel)(({ theme }) => ({
  '& .MuiStepLabel-root': {
    padding: theme.spacing(1, 0),
  },
  '& .MuiStepLabel-iconContainer': {
    paddingRight: theme.spacing(1.5),
  },
  '& .MuiStepLabel-labelContainer': {
    width: 'auto',
  },
  '& .MuiStepLabel-label': {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.text.secondary,
    lineHeight: '20px',
  },
  '& .MuiStepLabel-label.Mui-active': {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  '& .MuiStepLabel-label.Mui-completed': {
    color: theme.palette.success.main,
    fontWeight: 600,
  },
}));

const StepIcon = styled('div')(({ theme, ownerState }) => ({
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  fontSize: 20,
  ...(ownerState.completed && {
    color: theme.palette.success.main,
  }),
  ...(ownerState.active && {
    color: theme.palette.warning.main,
  }),
  ...(!ownerState.active && !ownerState.completed && {
    color: theme.palette.grey[300],
  }),
}));

function CustomStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    completed: <CheckCircleIcon sx={{ fontSize: 24 }} />,
    active: <FiberManualRecordIcon sx={{ fontSize: 16 }} />,
    inactive: <RadioButtonUncheckedIcon sx={{ fontSize: 24 }} />,
  };

  let icon;
  if (completed) {
    icon = icons.completed;
  } else if (active) {
    icon = icons.active;
  } else {
    icon = icons.inactive;
  }

  return (
    <StepIcon ownerState={{ completed, active }} className={className}>
      {icon}
    </StepIcon>
  );
}

export default function StatusStepper({ activeStep = 0 }) {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: 'text.primary' }}>
        Order Progress
      </Typography>
      <Stepper
        orientation="vertical"
        activeStep={activeStep}
        connector={<ModernConnector />}
        sx={{ 
          '& .MuiStep-root': {
            paddingBottom: 2,
          },
          '& .MuiStep-root:last-child': {
            paddingBottom: 0,
          }
        }}
      >
        {statuses.map((label, index) => (
          <Step key={label}>
            <ModernStepLabel StepIconComponent={CustomStepIcon}>
              <Box>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    fontWeight: index <= activeStep ? 600 : 500,
                    color: index < activeStep ? '#4caf50' : 
                           index === activeStep ? '#FF8A00' : '#666',
                    mb: 0.5
                  }}
                >
                  {label}
                </Typography>
                {/* {index === activeStep && (
                  <Typography variant="caption" sx={{ color: '#999' }}>
                    In progress
                  </Typography>
                )}
                {index < activeStep && (
                  <Typography variant="caption" sx={{ color: '#4caf50' }}>
                    Completed
                  </Typography>
                )} */}
              </Box>
            </ModernStepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
